import * as types from '../actions/actionTypes';

const initialState = {
  transactions: [],
  transactionsLoaded: false,
  merchantBalance: 0,
};

export const transactionsReducer = (state = initialState, action) => {
  switch (action.type) {
  case types.SET_BALANCE: {
    return {
      ...state,
      merchantBalance: action.merchantBalance,
    };
  }
  case types.LOAD_TRANSACTIONS: {
    return {
      ...state,
      transactions: action.transactions,
      transactionsLoaded: true,
    };
  }
  default:
    return state;
  }
};
